webpackJsonp([395],{

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2206:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1252),
  /* template */
  __webpack_require__(2962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/v2.1.1-rc.11_zh-CN-318.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.1-rc.11_zh-CN-318.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9ec1271c", Component.options)
  } else {
    hotAPI.reload("data-v-9ec1271c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2962:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更加流畅的遮罩层动画")])]), _vm._v(" "), _c('h2', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 作为插件使用时，每次都重置属性值")])]), _vm._v(" "), _c('h2', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复插件代码里的值和事件监听器")]), _vm._v(" "), _c('li', [_vm._v("[fix] 以插件方式显示时强制重置数据")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持格式化显示 prop:display-format #1086 @greedying")])]), _vm._v(" "), _c('h2', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 以插件形式使用时强制重置属性值")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 添加渐现动画")])]), _vm._v(" "), _c('h2', [_vm._v("PopupPicker")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 修复 Safari 下遮罩层渲染慢的问题 #1083 @sixiakun")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 默认开启 transfer-dom，解决非 Safari 也会出现的 z-index 问题")])]), _vm._v(" "), _c('h2', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复遮罩禁用点击时错误设置 overflowScrolling 的问题")])]), _vm._v(" "), _c('h2', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更流畅的遮罩动画和弹窗动画")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 添加 dom 转移到 body 下的 demo")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 移除无用代码")])]), _vm._v(" "), _c('h2', [_vm._v("XTextarea")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 on-focus on-blur 事件 #1082 @zeusLeeJh")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ec1271c", module.exports)
  }
}

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2206);

/***/ })

});


// WEBPACK FOOTER //
// 395.435dc818.js